import GradientBox from './GradientTransparent/GradientBox';
import GradientPrimary from './GradientPrimary/GradientPrimary';

export { GradientBox, GradientPrimary };
